const themeConfig = {
    // basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs, also don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '',
    defaultPath: '/dashboard/default',
    // fontFamily: `'Roboto', sans-serif`,
    fontFamily: `'Helvetica', 'Helvetica', sans-serif`,
    borderRadius: 12,
    colors: {
        // card
        card: '#ffffff',
        cardDark: '#2f3349',

        // paper
        paper: '#ffffff',
        paperDark: '#2f3349',

        // background
        background: '#f8f7fa',
        backgroundDark: '#25293c',
        backgroundDeepDark: '#4527a0',

        // box shadow
        boxShadow: '0 0 4px 0 rgba(31, 41, 64, 0.25)',
        boxShadowDark: '0 0 4px 0 rgba(31, 41, 64, 0.25)',

        // text color
        textColor: '#1F2940',
        textColorDark: '#fff',
        secondaryTextColor: 'rgba(31, 41, 64, 0.50)',
        secondaryTextColorDark: 'rgba(31, 41, 64, 0.50)',

        // primary
        primaryLight: '#8F85F3',
        primaryMain: '#7468F0',
        primaryDark: '#5048A8',
        primary200: '#b39ddb',
        primary800: '#4527a0',

        // secondary
        secondaryLight: '#B9BBBE',
        secondaryMain: '#a8aaae',
        secondaryDark: '#757679',
        secondary200: '#b0bec5',
        secondary800: '#37474f',
        contrastText: '#fff',

        // success Colors
        successLight: '#b9f6ca',
        success200: '#69f0ae',
        successMain: '#22BE70',
        successDark: '#00c853',

        // error
        errorLight: '#FF8D80',
        errorMain: '#FF5150',
        errorDark: '#DD3330',

        // orange
        orangeLight: '#fbe9e7',
        orangeMain: '#FF7030',
        orangeDark: '#FF7030',

        // warning
        warningLight: '#fff8e1',
        warningMain: '#FF8C00',
        warningDark: '#ffc107',

        // grey
        grey50: '#fafafa',
        grey100: '#f5f5f5',
        grey200: '#eeeeee',
        grey300: '#e0e0e0',
        grey500: '#9e9e9e',
        grey600: '#757575',
        grey700: '#616161',
        grey900: '#212121',

        // boderColor
        boderColorLight: '#0000003b',
        boderColorDark: '#ffffff3b',
    }

};
export default themeConfig;
